import axios from 'axios';
import _ from 'lodash';
import { COOKIE_EXPIRY_14_DAYS } from '../../../constants/defaults';

const errorHandler = err => {
  console.log(err);
};

export const sendReferralEmail = async data => {
  try {
    const response = await axios.post(
      `/api/referral/invites`,
      {
        emails: data
      },
      { withCredentials: true }
    );
    if (response) {
      return response.data;
    }
  } catch (err) {
    errorHandler(err);
    return err;
  }
};

export const getReferrerDetails = async refCode => {
  try {
    const response = await axios.get(`/api/referral/details/${refCode}`, {
      withCredentials: true
    });
    if (response) {
      response.data.firstName
        ? _.setCookie('refCode', refCode, COOKIE_EXPIRY_14_DAYS)
        : _.eraseCookie('refCode');
      return response.data;
    }
  } catch (err) {
    errorHandler(err);
    return err;
  }
};
